var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ActionTypes from '../actionTypes';
import { toEntityIdsList, toEntityMapById } from '../../shared/functions';
var initialState = {
    isFetching: false,
    didInvalidate: false,
};
/**
 * Derives the next "searchCriteria" state from the previous one and the current action.
 * The returned state is a brand a new object.
 */
var searchCriteriaReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.FETCH_SEARCH_CRITERIA_REQUEST:
            return (__assign(__assign({}, state), { isFetching: true, didInvalidate: false, ids: undefined, entities: undefined, error: undefined }));
        case ActionTypes.FETCH_SEARCH_CRITERIA_RESPONSE:
            return (__assign(__assign({}, state), { isFetching: false, ids: toEntityIdsList(action.payload), entities: toEntityMapById(action.payload) }));
        case ActionTypes.FETCH_SEARCH_CRITERIA_INVALIDATE:
            return (__assign(__assign({}, state), { isFetching: false, didInvalidate: true, error: action.error }));
        default:
            return state;
    }
};
export default searchCriteriaReducer;
